<template>
    <div>
        <div class="drop" v-if="images.length <= 0">
            <strong><i class="fa-regular fa-image"></i> Gallery</strong>
            <span>Drag and drop to upload files or </span>
            <a class="btn btn_primary-outline pl-5 pr-5 mt-3" @click="$refs.imageInput.click()">Select Files</a>
        </div>

        <div v-else>
            <span class="form-label">Gallery</span>
            <draggable v-model="images" @end="onDragEnd" class="files">
                <div class="files__item" v-for="(photo, index) in images" :key="photo.id">
                    <a :href="`/uploads/${photo.file_path}`" target="_blank">
                        <img :src="`/uploads/${photo.file_path}`" alt="Photo" width="120">
                    </a>
                    <button type="button" class="files__delete" @click="deleteImage(photo.id)">
                        <svg width="12" height="12" aria-hidden="true">
                            <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                        </svg>
                    </button>
                    <span class="files__num">{{ index + 1 }}</span>
                </div>
            </draggable>
            <div class="add-link mt-3">
                <a href="javascript:void(0)" @click="$refs.imageInput.click()">+ Add Photo</a>
            </div>
            <span class="form-note">To change the range of the images click and drag.</span>
        </div>

        <input
            type="file"
            style="display: none"
            ref="imageInput"
            accept="image/*"
            multiple
            @change="selectFiles"
        >
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import draggable from 'vuedraggable'
import AdminPanelService from "../../services/AdminPanelService";

export default defineComponent({
    components: { draggable },
    name: 'ImageGallery',
    props: {
        uploadedImages: {
            type: Array,
            default: () => []
        },
        uploadHandler: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            images: [],
            files: []
        }
    },
    methods: {
        async deleteImage(id) {
           try {
               this.images = this.images.filter(item => item.id !== id)
               await AdminPanelService.deleteFile(id)
               this.$showSuccessMessage('The photo was deleted')
           } catch (e) {
               console.error(e)
               this.$showErrorMessage('The photo was not deleted')
           }
        },
        onDragEnd() {
            const newOrderPhotos = this.images.map((image) => image.id)
            this.$emit('upload-gallery', newOrderPhotos )
        },
        async selectFiles() {
            const uploadedFiles = this.$refs.imageInput.files
            const validFiles = await this.validateAndPrepareFiles(uploadedFiles)

            if (validFiles.length === 0) return

            this.files = [
                ...new Map([...this.files, ...validFiles].map(item => [item.name, item])).values()
            ]

            await this.sendPhoto(validFiles)
        },
        async sendPhoto(files) {
            this.$showLoadingMessage()
            const formData = new FormData()
            for (let i = 0; i < files.length; i++) {
                formData.append('photos[]', files[i].file)
            }
            try {
                const { data: response } = await this.uploadHandler(formData)
                if (Array.isArray(response)) {
                    this.images = [...this.images, ...response]
                } else if (response && typeof response === 'object') {
                    this.images = [...this.images, response]
                }
                this.providePhotoIds()
                this.$showSuccessMessage('The photo/s was uploaded')
                this.files = []
            } catch (error) {
                this.$showErrorMessage()
            }

        },
        providePhotoIds() {
            const ids = this.images.map(i => i.id)
            this.$emit('upload-gallery', ids )
        },
        async validateAndPrepareFiles(uploadedFiles) {
            const MAX_FILE_SIZE = 150 * 1024 * 1024
            const files = await Promise.all(
                Array.from(uploadedFiles).map(async (file) => {
                    if (file.size > MAX_FILE_SIZE) {
                        this.$showErrorMessage(`The file ${file.name} exceeds the maximum size of 150 MB.`)
                    } else {
                        try {
                            const content = await this.readFileAsync(file)
                            return {
                                file,
                                name: file.name,
                                content
                            }
                        } catch (error) {
                            console.error('Помилка при читанні файлу:', error)
                            return null
                        }
                    }
                })
            )
            return files.filter(Boolean)
        },
        readFileAsync(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader()
                reader.onload = () => resolve(reader.result)
                reader.onerror = reject
                reader.readAsDataURL(file)
            })
        }
    },
    watch: {
        uploadedImages: {
            immediate: true,
            handler(val) {
                console.log('uploadedImages changed:', val)
                if (Array.isArray(val)) {
                    this.images = val
                } else {
                    this.images = []
                }
            }
        }
    },
})
</script>
